export enum LocalStorageKey {
  LANGUAGE = 'LANGUAGE',
  THEME = 'THEME',
  SETTINGS = 'SETTINGS'
}
